import { render, staticRenderFns } from "./EditAuctionItem.vue?vue&type=template&id=7848f166&scoped=true&"
import script from "./EditAuctionItem.vue?vue&type=script&lang=js&"
export * from "./EditAuctionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7848f166",
  null
  
)

export default component.exports